module.exports = __webpack_public_path__ + "static/media/Logo-Newspeak-PIcto.918bdf24.png";